export const GET_GROUPS = 'GET_GROUPS';
export const GET_GROUPS_SUCCEEDED = 'GET_GROUPS_SUCCEEDED';

export const SELECT_GROUP = 'SELECT_GROUP';
export const SET_DATE_FILTER = 'SET_DATE_FILTER';
